import { SendingType } from "us.common/constants";

export enum DateFormats {
  REQ = "YYYY-MM-DD",
  NIN = "DDMMYY",
  MIN_DATE = "0001-01-01",
}

export enum OtherPartyTypes {
  PERSON = "P",
  COMPANY = "N"
}

export enum RoleType {
  CONTACT_PERSON = 'contact person'
}

export const SENDING_TYPE_OPTIONS = [
  {
    label: "US.COLLECTION.CASE:OTHERPARTY.CARBON_COPY",
    value: SendingType.CARBON_COPY,
  },
  {
    label: "US.COLLECTION.CASE:OTHERPARTY.PRIMARY_COMMUNICATION_PARTY",
    value: SendingType.PRIMARY,
  },
  {
    label: "US.COLLECTION.CASE:OTHERPARTY.SECONDARY_COMMUNICATION_PARTY",
    value: SendingType.SECONDARY,
  },
];